export const getLevel = ({ document, currentBlock }) => {
  let tempkey = currentBlock.key;
  let level = 0;
  while (
    document.getParent(tempkey).type === 'list_item' ||
    document.getParent(tempkey).type === 'unordered_list'
  ) {
    tempkey = document.getParent(tempkey).key;
    if (document.getParent(tempkey).type === 'list_item') level += 1;
  }
  return level;
};

export default (editor) => {
  const { document, focusBlock } = editor.value;
  const level = getLevel({ document, currentBlock: focusBlock });
  return level;
};
